export function crearCarteles(scene) {

  // Cartel no va más
  scene.anims.create({
    key: "cartelNoVaMasAnimacion",
    frames: scene.anims.generateFrameNumbers("cartelNoVaMas", {
      start: 0,
      end: 18,
    }),
    frameRate: 10,
    repeat: -1,
  });

  scene.cartelNoVaMas = scene.add.sprite(868, 244, "cartelNoVaMas").setVisible(false);
  
  // Cartel hagan sus apuestas
  scene.anims.create({
    key: "cartelHaganSusApuestasAnimacion",
    frames: scene.anims.generateFrameNumbers("cartelHaganSusApuestas", {
      start: 0,
      end: 18,
    }),
    frameRate: 10,
    repeat: -1,
  });

  scene.cartelHaganSusApuestas = scene.add.sprite(868, 244, "cartelHaganSusApuestas").setVisible(false);

}